"use client";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";

export default function Faq() {
  const items = [
    {
      question: "Who are we?",
      answer:
        "Alpha Appraisals is a leading provider of real estate appraisal services in the Greater Toronto Area. We have a team of certified, insured, and experienced real estate appraisers. Choose us for trustworthy appraisal reports backed by certified professionals.",
    },
    {
      question: "Which cities do we serve?",
      answer:
        "We serve a wide range of cities in the Greater Toronto Area, including Toronto, Mississauga, Brampton, Vaughan, Markham, Oakville, Richmond Hill, Halton Hills, Etobicoke and more.",
    },
    {
      question: "What types of residential appraisals do we provide?",
      answer:
        "We provide appraisals for single-family homes, condominiums, estate home, multi-unit properties, vacant land, and more.",
    },
    {
      question: "Who are our intended users?",
      answer:
        "Our services cater to property owners, mortgage brokers, lawyers, realtors, potential buyers and individuals for various purposes such as property valuations, mortgage financing, taxation, estate settlements, and more.",
    },
    {
      question: "What is our training and insurance policy?",
      answer:
        "Our appraisers are insured and members of the Appraisal Institute of Canada. They meet strict requirements to provide accurate valuations.",
    },
    {
      question: "What are our appraisal request order terms and conditions?",
      answer: (
        <div>
          <h2>TERMS & CONDITIONS APPRAISAL REQUEST ORDER</h2>
          <br />
          <h3>1. Applicability</h3>
          <p>
            These general conditions are applicable to:
            <br />
            (a) Placing this Appraisal Request Order is considered an acceptance
            of our terms of use and agree to everything in this document,
            including general conditions, and
            <br />
            (b) the use, obtaining and reporting of any information, data,
            documents, text, graphics, and/or other services by our firm as we
            deem necessary and which is lawful.
          </p>
          <br />
          <h3>Appraisal Request Order to Our Firm</h3> <br />
          <p>
            <b>Eligibility to order an Appraisal Request Order</b>
            <br />
            In order to place an Appraisal Request Order, you must:
            <br />
            (a) Subject property Address
            <br />
            (b) be 18 years of age or older
            <br />
            (c) be a consumer – not a reseller
            <br />
            (d) be a licensed professional regulated by FSCO or be a licensed
            Lender, or a licensed Private Lender
            <br />
            (e) be regulated by (FSCO) Financial Services Commission of Ontario,
            or similar Provincial Regulator
            <br />
            (f) If the order is from the owners then the requester must have
            legitimate ownership of the subject property.
            <br />
            (g) you need an Email address and telephone number to place an
            Appraisal Request Order.
          </p>
          <br />
          <h3>2. How to order</h3>
          <p>
            Placing an order with us is easy:
            <br />
            (a) Submit your Appraisal Request Order through{" "}
            <a href="https://www.alphaappraisals.ca">
              https://www.alphaappraisals.ca
            </a>
            <br />
            (b) Fill out the Appraisal Request Order form applicable to order
            purpose, intended use and intended user.
            <br />
            (c) Identify the Intended User by Name, or by Type, for example:
            Owner/Co-owner or "Mortgage Broker" or "Private Lender"
            <br />
            (d) Intended user as: “To Be Determined (TBA)” is Unacceptable
            <br />
            (e) Intended user as: “To Be Arranged (TBD)” is Unacceptable
            <br />
            (f) Intended user as: “& A Lenders” is unacceptable
            <br />
            (g) Select payment options, Invoice, Email transfer, Money Order,
            Cash, or COD (Paid on inspection date and time). Personal &amp;
            Company cheque not acceptable.
            <br />
            (h) Provided requester contact phone number
          </p>
          <br />
          <p>
            You are bound by your Appraisal Request Order once you have
            submitted it. We will contact you once we have received your
            appraisal request order within 12 hours via email and/or phone call
            to confirm if the Appraisal Request Order has now been concluded.
            The Appraisal Assignment has not been concluded.
          </p>
          <br />
          <p>
            At any time, we explicitly reserve the right not to accept or to
            cancel your Appraisal Request Order after the confirmation was sent
            to you at any time.
            <br /> <br />
            <b>
              Our right to not accept your Appraisal Request Order, to cancel or
              decline:
            </b>
            <br />
            We reserve the right to refuse any Appraisal Request Order for any
            reason whatsoever at any time.
            <br />
            We also reserve the right to cancel any appraisal request order
            already accepted by us in the following situations, without being
            liable for any damage or costs:
            <br />
            - by impossibility of performance, or contract termination;
            <br />
            - if the information for the party or parties paying for the service
            is incorrect, not verifiable, or non-payment of fee;
            <br />
            - if proof of payment for our appraisal services has not been
            received by our firm;
            <br />
            - if there was an error in the price quote;
            <br />
            - if the information you provided has errors in it;
            <br />
            - if the Subject Property information, Appraisal Requester's,
            Homeowner's, Mortgage Broker's, or Lender's information is incorrect
            or not verifiable;
            <br />
            - if the subject property address being appraised is incorrect or
            not verifiable;
            <br />
            - if the Builder's sales are unwilling to cooperate for site
            inspection;
            <br />
            - if your order is flagged up by our security systems as an unusual
            order or an order susceptible to fraud;
            <br />
            - if we have reason to believe you are under 18 years of age;
            <br />
            - if we have reason to believe that you are a reseller;
            <br />
            - if we could not deliver the appraisal report to the requester's
            intended users, and or mortgage broker Email address provided;
            <br />
            - if the applicant, homeowner, home buyer, mortgage broker or their
            agent, the real estate sales representatives, or agents involved for
            the transaction or mortgage, delayed in providing required
            informations, inspection during the appraisal process;
            <br />
            - if there is inclement weather conditions, traffic delays, internet
            delays, computer software disruption, computer and/or computer
            server network disruption, electrical power failure, or any form of
            delay;
            <br />
            - whether intentional or not, if any person caused a delay in the
            appraisal process we reserve the right to change the initial
            agreement or cancel it altogether;
            <br />
            - if there is a delay by any of the parties in the home inspection,
            a delay in the appraisal process, or a delay in completing the
            appraisal assignment, which resulted in changing the terms of our
            initial agreement;
            <br />- we also reserve the right to change the terms of the initial
            agreement at any time due to unforeseen circumstances that are
            beyond our control.
          </p>
          <br />
          <p>
            <b>Payment for our appraisal services</b>
            <br />
            Payment for our appraisal services must be made by (Email Transfer,
            Direct Deposit, Money Order, Cash, by Mortgage Broker, or in person
            by owners, unless we have agreed to Invoice a Lender or Mortgage
            Broker or their Agents which must be confirmed in writing or by
            E-mail.
          </p>
          <br />
          <p>
            <b>Acceptance</b>
            <br />
            By placing the Appraisal Request Order, you acknowledge and agree to
            the Terms of Use, you also acknowledge and agree to the General
            Conditions, and you accept all of the aforementioned statements.
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="mx-auto max-w-4xl   sm:-mt-1 ">
      {" "}
      {items.map((item, index) => (
        <Disclosure key={index}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex font-cinzel justify-between text-xl w-full  p-5 text-left border  border-gray-200 hover:bg-blue-500 hover:text-white  dark:hover:text-white">
                <span className="font-bold">{item.question}</span>
                <ChevronUpIcon
                  className={`${
                    open ? "transform rotate-180" : ""
                  } w-5 h-5 text-gray-500`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="p-10 sm:p-10 font-lighter border border-t-0 text-lg border-gray-200">
                <p id={index}>{item.answer}</p>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
}
